export class UserRole {
    roleID: number;
    name: string;
    description: string;
    creationDate?: Date;
    creationUser?: string;
    modificationDate?: Date;
    modificationUser?: string;
    status?: number;
}
